import React from 'react';

import PropTypes from 'prop-types';

import PcLogo from '@/assets/images/LogoPC.png';
import * as APPDATA from '@/constants/pcConstAppData';
import {newLineHtml} from '@/libs/htmlHelper';

import Button from '../button/Button';

import './ErrorPageContent.less';

function ErrorPageContent({restartVisible, onClick}) {
  const onClickAction = (e) => {
    onClick(e);
  };
  return (
    <div className="errorPage">
      <div className="rowLogo">
        <img
          src={PcLogo}
          className="logo"
          alt="logo"
        />
      </div>
      <div className="rowLogoName">
        <span className="logoName">
          {APPDATA.PRODUCT_NAME.replace('®', '')} TFF <sup>®</sup>
        </span>
      </div>
      <div className="rowTitle">
        <span className="title">{APPDATA.MESSAGES.ERROR_PAGE.TITLE}</span>
      </div>
      <div className="rowText">
        <span className="text">
          {restartVisible
            ? newLineHtml(APPDATA.MESSAGES.ERROR_PAGE.RESTART_TEXT)
            : newLineHtml(APPDATA.MESSAGES.ERROR_PAGE.RELOAD_TEXT)}
        </span>
      </div>
      <div className="rowButton">
        {restartVisible ? (
          <Button
            id={APPDATA.RESTART}
            onClick={onClickAction}
            className="button center"
            label={APPDATA.MESSAGES.ERROR_PAGE.RESTART_BUTTON}
          />
        ) : (
          <Button
            id={APPDATA.RELOAD}
            onClick={onClickAction}
            className="button center"
            label={APPDATA.MESSAGES.ERROR_PAGE.RELOAD_BUTTON}
          />
        )}
      </div>
    </div>
  );
}

ErrorPageContent.propTypes = {
  restartVisible: PropTypes.bool,
  onClick: PropTypes.func,
};

ErrorPageContent.defaultProps = {
  restartVisible: true,
  onClick: () => {},
};
export default ErrorPageContent;
